import * as React from 'react';

import SOVQueriesModalConsumerInsightsInstagram from '../instagram/modals/SOVQueriesModalConsumerInsightsInstagram';

import { INSTAGRAM } from 'modules/insights/sov/utils/sov';

import type {
  SOVGeneralActionType,
  SOVGeneralModalTextFields,
  SOVQueryLocal,
  SOVQueryStep,
  SOVQueryType,
  SOVReport
} from 'modules/insights/sov/types';

type Props = {
  report: SOVReport,
  query: SOVQueryLocal,
  isMulti: boolean,
  actionType: SOVGeneralActionType,
  activeTab: string,
  stepIndex: number,
  stepCount: number,
  stepDirection: number,
  stepInfo: SOVQueryStep,
  textFields: SOVGeneralModalTextFields,
  onRenderActionButton: (a: boolean) => React.ReactNode,
  onRenderBackButton: () => React.ReactNode | undefined | null,
  onRenderCancelButton: () => React.ReactNode | undefined | null,
  onTextFieldChange: (b: string, a: string) => void,
  onRadioButtonChange: (a: SOVQueryType) => void,
  onTabsSwitch: (a?: string | null) => void
};

class SOVQueriesModalConsumerInsights extends React.PureComponent<Props> {
  renderInstagram(): React.ReactNode {
    const {
      report,
      query,
      isMulti,
      actionType,
      activeTab,
      stepIndex,
      stepCount,
      stepDirection,
      stepInfo,
      textFields,
      onRenderActionButton,
      onRenderCancelButton,
      onRenderBackButton,
      onTextFieldChange,
      onRadioButtonChange,
      onTabsSwitch
    } = this.props;

    return (
      <div className="sov-queries-modal-consumer-insights__instagram">
        <SOVQueriesModalConsumerInsightsInstagram
          report={report}
          query={query}
          isMulti={isMulti}
          actionType={actionType}
          activeTab={activeTab}
          stepIndex={stepIndex}
          stepCount={stepCount}
          stepDirection={stepDirection}
          stepInfo={stepInfo}
          textFields={textFields}
          onRenderActionButton={onRenderActionButton}
          onRenderCancelButton={onRenderCancelButton}
          onRenderBackButton={onRenderBackButton}
          onTextFieldChange={onTextFieldChange}
          onRadioButtonChange={onRadioButtonChange}
          onTabsSwitch={onTabsSwitch}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    const { report } = this.props;

    return (
      <div className="sov-queries-modal-consumer-insights">
        {
          report.reportType === INSTAGRAM
            && this.renderInstagram()
        }
      </div>
    );
  }
}

export default SOVQueriesModalConsumerInsights;
